import _isEmpty from 'lodash/isEmpty';

export function generateHelpText(helpText, defaultValue) {
  if (_isEmpty(defaultValue)) {
    return helpText || '';
  }
  return `${helpText}. Its default value is: '${defaultValue}'.`;
}

export function getOriginalContent(contentNode) {
  const { content, contentType, id } = contentNode;
  return { content, type: contentType.toLowerCase(), id };
}
